import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { DrawerModule } from 'primeng/drawer';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ProfileService } from '@/services/profile.service';
import { RoleService } from '@/services/role.service';
import { UserService } from '@/services/user.service';
import { Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [
    DrawerModule,
    ReactiveFormsModule,
    InputTextModule,
    ButtonModule,
    RouterModule,
    CommonModule
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent implements OnInit {

  profileForm!: FormGroup;
  loading = false;
  appModalVisible = true;
  modalHeader = 'Profile';
  userInfo: any;
  private userProfile!: any;

  userTypeId = [
    { label: 'COZENTUS_USER', value: 5 },
    { label: 'CLIENT_USER', value: 10 }
  ];
  roles: any[] = [];

  @Output() closed = new EventEmitter<void>();


  constructor(
    private fb: FormBuilder,
    private profileService: ProfileService,
    private roleService: RoleService,
    private userService: UserService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.getProfile();

  }


  private initForm(): void {
    this.profileForm = this.fb.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: [{ value: '', disabled: true }],
      // phone_number: ['']
    });
  }

  isInvalid(controlName: string): boolean {
    const control = this.profileForm.get(controlName);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }



  getProfile() {
    const userInfo = this.profileService.getProfileFromLocal();
    if (userInfo) {
      const parsedUserInfo = JSON.parse(userInfo);
      this.userInfo = parsedUserInfo;
      this.profileForm.patchValue({
        first_name: parsedUserInfo.first_name,
        last_name: parsedUserInfo.last_name,
        email: parsedUserInfo.email,
        // phone_number: parsedUserInfo.phone_number
      });
    } else {
      console.error('userInfo not found in localStorage');
    }

  }


 updateProfile(): void {
  this.loading = true;
  const formValues = this.profileForm.getRawValue();

  const payload = {
    first_name: formValues.first_name,
    last_name: formValues.last_name,
    // phone_number: formValues.phone_number,
  };

  this.profileService.updateProfile(payload, this.userInfo.id).subscribe({
    next: () => {
      this.loading = false;

      const updatedUserInfo = {
        ...this.userInfo,
        ...payload
      };

      localStorage.setItem('userInfo', JSON.stringify(updatedUserInfo));
      this.userInfo = updatedUserInfo;

      this.profileForm.patchValue({
        first_name: updatedUserInfo.first_name,
        last_name: updatedUserInfo.last_name,
        phone_number: updatedUserInfo.phone_number
      });

      this.userService.refreshUserInfo();
      this.closeModal()

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Profile updated successfully'
      });

    },
    error: (err: any) => {
      this.loading = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: err?.error?.message || 'Profile update failed. Please try again.'
      });
    }
  });
}
  closeModal(): void {
    this.appModalVisible = false;
    this.profileForm.reset();

    this.closed.emit();
  }

}
